import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { getDataSetAndVersionReport } from '../../actions/reports';
import { storeWithExpiration } from '../../utils/common';
import SingleDatasetReportsContainer from './SingleDatasetReportsContainer';
import Loading from '../shared/Loading';

export class SingleDatasetReportsPage extends Component {
  static propTypes = {
    datasetId: PropTypes.string.isRequired,
    getDataSetAndVersionReportAction: PropTypes.func.isRequired,
    selectedDataset: PropTypes.object,
  };

  static defaultProps = {
    selectedDataset: null,
  };

  componentWillMount = () => {
    const { datasetId, selectedDataset, getDataSetAndVersionReportAction } = this.props;
    if (selectedDataset.get('id') !== parseInt(datasetId, 10)) {
      const token = storeWithExpiration.get('token');
      getDataSetAndVersionReportAction(parseInt(datasetId, 10), token);
    }
  };

  renderNoReports = () => <p>There are no reports associated with this dataset</p>;

  render() {
    const { datasetId, selectedDataset } = this.props;
    const isLoaded = selectedDataset.get('id') === parseInt(datasetId, 10);

    return isLoaded ? (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body">
              <div className="row">
                <div className="col-sm-12">
                  <h1 className="header-title">
                    <Link to={`/data/dataset/${datasetId}`}>
                      <i className="fa fa-angle-left" /> {selectedDataset.get('name')}
                    </Link>
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card-border">
                <div className="card-header">
                  <div className="card-header-title">Dataset Reports</div>
                </div>
                <div className="card-block">
                  <div className="row">
                    <SingleDatasetReportsContainer isIndexItem={false} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <Loading />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { reports } = state;
  const { params } = ownProps;
  const { datasetId } = params;
  const selectedDataset = reports.get('selectedDataset');
  return {
    datasetId,
    selectedDataset,
  };
};

export default connect(
  mapStateToProps,
  {
    getDataSetAndVersionReportAction: getDataSetAndVersionReport,
  }
)(SingleDatasetReportsPage);
